import { lazy } from 'react';

// 使用懒加载导入所有页面组件
const Index = lazy(() => import('../pages/index/index'));
const Sustainable = lazy(() => import('../pages/Sustainable'));
const CaseStudies = lazy(() => import('../pages/CaseStudies'));
const Future = lazy(() => import('../pages/Future'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const Terms = lazy(() => import('../pages/Terms'));



// 路由配置
const routes = [
  {
    path: '/',
    key: 'index',
    element: <Index />,
    exact: true,
  },//Home
  {
    path: '/industries',
    key: 'industries',
    element: <Sustainable />,
  },//Industries & Advantages
  {
    path: '/services',
    key: 'services',
    element: <CaseStudies/>,
  },//Services
  {
    path: '/future',
    key: 'future',
    element: <Future />,
  },//Future
  {
    path: '/privacy-policy',
    key: 'privacy-policy',
    element: <PrivacyPolicy />,
  },//Privacy Policy
  {
    path: '/terms',
    key: 'terms',
    element: <Terms />,
  },//Terms of Service


];

export default routes;